<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 12.074 14.916">
  <g data-name="Groupe 7011">
    <g fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round"
      data-name="Groupe 7012">
      <path
        d="M1.651 8.391V6.002l-.858-.861A1 1 0 0 1 .5 4.432v-.265a1 1 0 0 1 1-1h9.069a1 1 0 0 1 .709 1.711l-.947.947v5.141a3.631 3.631 0 0 1-1.063 2.567l-.212.212a2.3 2.3 0 0 1-1.627.674H4.594a2.3 2.3 0 0 1-1.45-.517l-.152-.123a3.631 3.631 0 0 1-1.341-2.818"
        data-name="Tracé 3718" vector-effect="non-scaling-stroke" />
      <path d="M4.659 6.827v4.13" data-name="Ligne 2061" vector-effect="non-scaling-stroke" />
      <path d="M7.416 6.827v4.13" data-name="Ligne 2062" vector-effect="non-scaling-stroke" />
      <path d="M3.922 1.31h0a.809.809 0 0 1 .81-.81h2.611a.81.81 0 0 1 .81.81"
        data-name="Tracé 3719"
        vector-effect="non-scaling-stroke" />
    </g>
  </g>
</svg>